import { create } from "zustand";
import { persist } from "zustand/middleware";
import { ALL_COMPANY_IDS } from "@/domain/tenantUsers";
import { platformRoleHasPermission } from "@/domain/platformPermissions";
import { resolveCustomerPermissions } from "@/lib/mockAuth";
import { useAccessStore } from "@/store/access.store";
import { usePlatformStore } from "@/store/platform.store";
import { usePlatformSessionStore } from "@/store/platformSession.store";
import { useSessionStore } from "@/store/session.store";

const useWorkspaceStore = create()(
  persist(
    (set, get) => ({
      impersonation: null,
      startCustomerPreview: (
        customerId,
        returnPath = "/platform/customers",
      ) => {
        const operator = usePlatformSessionStore.getState().operator;
        if (
          !operator ||
          !platformRoleHasPermission(operator.roleId, "platform.impersonate")
        ) {
          return false;
        }
        const customer = usePlatformStore.getState().getCustomer(customerId);
        if (!customer || customer.status === "suspended") return false;
        const modules = { ...customer.modules };
        const permissions = resolveCustomerPermissions("group_admin", modules);
        useSessionStore.getState().signInPreview({
          email: operator.email,
          name: `Workspace · ${customer.shortName ?? customer.name}`,
          systemCustomerId: customerId,
          permissions,
          modules,
          companyIds: ALL_COMPANY_IDS,
        });
        set({ impersonation: { customerId, returnPath } });
        return true;
      },
      endCustomerPreview: () => {
        const returnPath =
          get().impersonation?.returnPath ?? "/platform/dashboard";
        set({ impersonation: null });
        useSessionStore.getState().signOut();
        useAccessStore.getState().bindSessionAccess(
          "group_admin",
          ALL_COMPANY_IDS,
          [],
          {},
        );
        return returnPath;
      },
      isCustomerPreview: () => Boolean(get().impersonation),
    }),
    { name: "gps-erp-next-workspace" },
  ),
);

export { useWorkspaceStore };
